import { useMediaQuery, useTheme } from '@mui/material'

export interface UseMobileDialogOptions {
  /**
   * Breakpoint debajo del cual el modal se comporta como móvil.
   * Por defecto: 'sm' (< 600px).
   */
  breakpoint?: 'xs' | 'sm' | 'md'
}

/**
 * Hook para optimizar Diálogos en dispositivos móviles.
 * Proporciona `isMobile`, `fullScreen` y `dialogProps` preconfigurados
 * para aplicar fácilmente `fullScreen` adaptativo en modales grandes o complejos.
 *
 * @example
 * ```tsx
 * const { dialogProps } = useMobileDialog()
 * return (
 *   <Dialog open={open} onClose={handleClose} {...dialogProps}>
 *     <DialogTitle>Mi Diálogo</DialogTitle>
 *     ...
 *   </Dialog>
 * )
 * ```
 * @author isi-template
 */
export const useMobileDialog = (options: UseMobileDialogOptions = {}) => {
  const { breakpoint = 'sm' } = options
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down(breakpoint))

  return {
    isMobile,
    fullScreen: isMobile,
    dialogProps: {
      fullScreen: isMobile,
    },
  }
}

export default useMobileDialog
